import { useState } from "react";

const defaultVerifSettingPengecekan = {
  jabatan_id: -1,
  supir: [],
  staff: [],
  keamanan: [],
};

const defaultVerifSettingPemakaian = {
  jabatan_id: -1,
  1: [],
  2: [],
};

// rows of one setting ("pengecekan_mobil:supir", "pemakaian_mobil:1", ...) -> { jabatan_id, <role>: [jabatan ids] }
const buildVerifSetting = ({ rows, prefix, defaultSetting, jabatanId }) => {
  const newVerifSetting = {
    ...defaultSetting,
    jabatan_id: jabatanId,
  };
  for (const verifData of rows) {
    const { id, label, jabatan_id } = verifData;
    const newVerifLabel = label.replace(`${prefix}:`, "").trim();
    newVerifSetting[newVerifLabel].push(jabatan_id);
  }
  return newVerifSetting;
};

const useEditorVerifSetting = ({ requestGet, uiContext, employee }) => {
  const [verifSettingPengecekan, setVerifSettingPengecekan] = useState({
    ...defaultVerifSettingPengecekan,
  });
  const [verifSettingPemakaian, setVerifSettingPemakaian] = useState({
    ...defaultVerifSettingPemakaian,
  });

  // one request for both settings: the label filters are OR-ed ("||"), the rows are split by their label afterwards
  const fetchVerifSetting = async () => {
    requestGet({
      fullUrl: "/api/masterdata/verifsetting/data",
      params: {
        filter: `label:contains:pengecekan_mobil%||label:contains:pemakaian_mobil%`,
        page: 1,
        take: 1000,
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data, message }) => {
        const pengecekanRows = data
          ? data.filter((row) => row.label.includes("pengecekan_mobil"))
          : [];
        if (pengecekanRows.length > 0) {
          setVerifSettingPengecekan(
            buildVerifSetting({
              rows: pengecekanRows,
              prefix: "pengecekan_mobil",
              defaultSetting: defaultVerifSettingPengecekan,
              jabatanId: employee.jabatan_id,
            })
          );
        }

        const pemakaianRows = data
          ? data.filter((row) => row.label.includes("pemakaian_mobil"))
          : [];
        if (pemakaianRows.length > 0) {
          setVerifSettingPemakaian(
            buildVerifSetting({
              rows: pemakaianRows,
              prefix: "pemakaian_mobil",
              defaultSetting: defaultVerifSettingPemakaian,
              jabatanId: employee.jabatan_id,
            })
          );
        }
      },
    });
  };

  return {
    verifSettingPengecekan,
    verifSettingPemakaian,
    fetchVerifSetting,
  };
};

export default useEditorVerifSetting;
